module.exports = __webpack_public_path__ + "static/media/process-img1.66790d37.webp";